"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
exports.LanguageContextProvider = WrapReactIntl;
const react_1 = __importDefault(require("react"));
const build_context_1 = __importDefault(require("~/components/jsx-helpers/build-context"));
const react_intl_1 = require("react-intl");
const en_1 = __importDefault(require("~/lang/en"));
const es_1 = __importDefault(require("~/lang/es"));
function useContextValue() {
    var _a;
    const [language, setLanguage] = react_1.default.useState(((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('oswebLanguage')) || 'en');
    // Copy it to localStorage for later defaulting
    react_1.default.useEffect(() => { var _a; return (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem('oswebLanguage', language); }, [language]);
    return { language, setLanguage };
}
const { useContext, ContextProvider } = (0, build_context_1.default)({ useContextValue });
exports.default = useContext;
function ReactIntlUsingLanguage({ children }) {
    const { language } = useContext();
    const messages = react_1.default.useMemo(() => {
        switch (language) {
            case 'es':
                return es_1.default;
            default:
                return en_1.default;
        }
    }, [language]);
    return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: language, messages: messages }, children));
}
function WrapReactIntl({ children }) {
    return (react_1.default.createElement(ContextProvider, null,
        react_1.default.createElement(ReactIntlUsingLanguage, null, children)));
}
